import { Collapse as CollapseAntd, CollapseProps as CollapsePropsAntd } from 'antd'

interface CollapseProps extends CollapsePropsAntd {}

export const Collapse = ({ size = 'small', ...props }: CollapseProps) => {
  return <CollapseAntd size={size} {...props} />
}
